export const TEST_IDS = {
  TWO_CLICK_APP_INSTALL_PRODUCT_FOCUSED_TASK: 'two-click-app-install-product-focused-task'
};